// logic taken from https://pawelgrzybek.com/page-scroll-in-vanilla-javascript/

const easings = {
  linear(t) {
    return t;
  },
  easeOutQuad(t) {
    return t * (2 - t);
  },
};

const getNow = () => {
  return 'now' in window.performance ? performance.now() : new Date().getTime();
};

export const scrollIt = (destination, duration = 200, easing = 'linear', callback) => {
  const start = window.pageYOffset;
  const startTime = getNow();

  const documentHeight = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight,
  );

  const windowHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.getElementsByTagName('body')[0].clientHeight;

  const destinationOffset = destination.getBoundingClientRect().top + window.scrollY;

  const destinationOffsetToScroll = Math.round(
    documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset,
  );

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  const scroll = () => {
    const time = Math.min(1, (getNow() - startTime) / duration);
    const timeFunction = easings[easing](time);
    window.scroll(0, Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start));

    if (window.pageYOffset === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    requestAnimationFrame(scroll);
  };

  scroll();
};

const scrollToSection = (id) => () => {
  const section = document.getElementById(id);
  scrollIt(section, 300, 'easeOutQuad', () => undefined);
};

export default scrollToSection;
